module.exports = __webpack_public_path__ + "img/last_section_phone.8b4663b8.png";